import { User } from '~/app/shared/types/user/user.type';

/**
 * Champs conseiller requis pour considérer le profil comme « complet » (EF-3852).
 * La photo (`photoUrl`) et `isCif` sont volontairement exclus : la photo est supprimable
 * (elle ne doit pas faire revenir la popin) et `isCif` est un booléen qui n'est jamais « vide ».
 *
 * ⚠️ `regulatoryRegistrationNumber` n'est renvoyé que par `GET /members/me` / `GET /members/{id}`,
 * pas par le payload de login → alimenter cette fonction avec un `user` fraîchement rafraîchi.
 */
const REQUIRED_FIELDS = [
    'firstName',
    'lastName',
    'email',
    'phone',
    'regulatoryRegistrationNumber',
] as const satisfies readonly (keyof User)[];

const hasText = (value: unknown): boolean => typeof value === 'string' && value.trim().length > 0;

export const isProfileComplete = (user: User | undefined): boolean => {
    if (!user) {
        return false;
    }
    return REQUIRED_FIELDS.every((field) => hasText(user[field]));
};
